import React, { useMemo } from 'react';

import { useFreecodeContext } from 'hooks/useContext';
import FreecodeText from './FreecodeText';
import getComputedDescription from './getComputedDescription';

export default function FreecodeDescription({ isCreator = false }) {
  const { test, testImpl, language } = useFreecodeContext();

  // TODO get exercise level from editor

  const memoizedDescription = useMemo(
    () => getComputedDescription(testImpl.candidateDescription, test.category, language, 1),
    [testImpl.candidateDescription, test.category, language]
  );

  // TODO handle edit of text

  return <FreecodeText title={test.name} textContent={memoizedDescription} isCreator={isCreator} />;
}
